import React from "react";

interface SummaryCardProps {
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
  colorClass: string;
}

const SummaryCard: React.FC<SummaryCardProps> = ({
  icon,
  label,
  value,
  colorClass,
}) => (
  <div className="bg-white rounded-lg shadow border border-gray-100 p-5 relative overflow-hidden">
    <div
      className={`absolute top-0 right-0 w-20 h-20 ${colorClass} opacity-10 rounded-bl-full`}
    ></div>
    <div className="relative">
      <div className="flex items-start justify-between">
        <div className="text-sm font-medium text-gray-500 uppercase tracking-wide">
          {label}
        </div>
        <div
          className={`w-8 h-8 ${colorClass} rounded-full flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300`}
        >
          {icon}
        </div>
      </div>
      <div className="mt-4 text-left">
        <div className="text-3xl font-bold text-gray-900 leading-tight">
          {value}
        </div>
      </div>
    </div>
  </div>
);

export default SummaryCard;
